import { ChevronLeft, ChevronRight } from "lucide-react";

const KEY = "snaplist.libraryNav";

export const saveLibraryOrder = (ids) => { try { sessionStorage.setItem(KEY, JSON.stringify(ids)); } catch { /* storage full */ } };

export const libraryNeighbors = (id) => {
  let ids = [];
  try { ids = JSON.parse(sessionStorage.getItem(KEY) || "[]"); } catch { ids = []; }
  const i = ids.indexOf(id);
  return { index: i, total: ids.length, prev: i > 0 ? ids[i - 1] : null, next: i >= 0 && i < ids.length - 1 ? ids[i + 1] : null };
};

export function DraftPager({ nav, onGo, busy }) {
  if (nav.index < 0 || nav.total < 2) return null;
  const btn = "flex h-8 w-8 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 transition-colors hover:text-[#0053DA] disabled:opacity-30";
  return (
    <div className="flex items-center justify-between rounded-full border border-slate-200 bg-white/80 px-1 py-1" data-testid="draft-pager">
      <button type="button" onClick={() => onGo(nav.prev)} disabled={!nav.prev || busy} aria-label="Previous draft" className={btn} data-testid="draft-prev"><ChevronLeft className="h-4 w-4" /></button>
      <span className="font-mono text-[11px] text-slate-500" data-testid="draft-position">{busy ? "Saving…" : `Draft ${nav.index + 1} of ${nav.total} · swipe to browse`}</span>
      <button type="button" onClick={() => onGo(nav.next)} disabled={!nav.next || busy} aria-label="Next draft" className={btn} data-testid="draft-next"><ChevronRight className="h-4 w-4" /></button>
    </div>
  );
}
